import React from 'react';

import { useDataAttributes } from '@lumapps/data-attributes';
import { directoriesRoute } from '@lumapps/directories-back-office/routes';
import { DEFAULT_DIRECTORY_MDI_ICON } from '@lumapps/directories/constants';
import { Menu } from '@lumapps/lumx-menu/components/Menu';
import { Link as RouterLink } from '@lumapps/router';
import { useTranslate, GLOBAL } from '@lumapps/translations';

export interface DirectoriesSettingsMenuProps {
    /**
     * Check if the user has the permissions to access the directories settings
     */
    isAllowed: boolean;
    /**
     * Scope for data attributes
     */
    scope: string;
}

/**
 * A menu item that links to the directories settings page
 * It renders a menu item if the user has the required permissions.
 */
export const DirectoriesSettingsMenu: React.FC<DirectoriesSettingsMenuProps> = ({ isAllowed, scope }) => {
    // Get the data attributes for the scope
    const { get } = useDataAttributes(scope);
    // Get the translate function
    const { translateKey } = useTranslate();

    if (!isAllowed) {
        return null;
    }

    return (
        <Menu.Item
            icon={DEFAULT_DIRECTORY_MDI_ICON}
            as={RouterLink}
            to={directoriesRoute}
            {...get({ element: 'directories' })}
        >
            {translateKey(GLOBAL.DIRECTORIES)}
        </Menu.Item>
    );
};

DirectoriesSettingsMenu.displayName = 'DirectoriesSettingsMenu';
